export const INIT_COUNTRY = 'INIT_COUNTRY';
export const FETCH_COUNTRY_LIST_START = 'FETCH_COUNTRY_LIST_START';
export const FETCH_COUNTRY_LIST_SUCCESS = 'FETCH_COUNTRY_LIST_SUCCESS';
export const FETCH_COUNTRY_LIST_ERROR = 'FETCH_COUNTRY_LIST_ERROR';
